import {Normalizer, SnapshotEntity} from "../types";

// 'sgkhaciz' alanı normalizer'ı — BorcluSgkHaciz.parse() çıktısını (BorcluSgkHacizCevap)
// SnapshotEntity[]'e indirger.
//
// parse() (BorcluSgkHaciz.ts:46-60) zaten sorguSonucDVO dizisini show:true olanlara
// süzüp her kalan elemana selected:true ekliyor. ISgkHacizSonuc arayüzünde
// kisiTipString/show/selected dışında alan yok; show her zaman true (süzülmüş),
// selected parse'ın eklediği sabit true — ikisi de attrs'a taşınacak anlamlı veri
// değil, bu yüzden attrs her zaman boş nesne olarak bırakılıyor.
//
// SAF FONKSİYON: girdiyi mutasyona uğratmaz, throw etmez.
export const sgkhacizNormalizer: Normalizer = (cevap) => {
    const liste = cevap?.sorguSonucDVO;

    if (!Array.isArray(liste)) {
        // parse() yalnız sorguSonucDVO dizi ise dokunuyor; hata/boş cevaplarda
        // alan hiç olmayabilir (undefined) ya da beklenmeyen bir şekil taşıyabilir.
        return {entities: []};
    }

    const entities: SnapshotEntity[] = [];

    for (const kayit of liste) {
        const key = typeof kayit?.kisiTipString === "string" ? kayit.kisiTipString.trim() : "";

        if (!key) {
            // kisiTipString yoksa/boşsa kararlı bir entity anahtarı üretilemez —
            // bu kaydı sessizce atla, geri kalanları işlemeye devam et.
            continue;
        }

        entities.push({
            key,
            label: key,
            attrs: {}
        });
    }

    return {entities};
};
